export enum PersonalInformationEditCardType {
  NAME = "Name",
  EMAIL = "Email",
  PHONE = "Phone",
  PASSWORD = "Password"
}
